import { useEffect } from 'react';
import { listCoursesWatchData } from './graphql/queries';

export default function useCourses({ setWatchDataError, useLazyGraphQLQuery }) {
  const [listCoursesWatchDataQuery, listCoursesWatchDataResponse] =
    useLazyGraphQLQuery(listCoursesWatchData);

  useEffect(() => {
    const { error } = listCoursesWatchDataResponse;

    if (error) {
      setWatchDataError(true);
    }
  }, [listCoursesWatchDataResponse]);

  return {
    allCoursesStats: listCoursesWatchDataResponse.data?.listCoursesWatchData,
    loadingCoursesWatchData: listCoursesWatchDataResponse.loading,
    fetchCoursesWatchData: listCoursesWatchDataQuery,
  };
}
